import script from "./CameraInfoNav.vue?vue&type=script&lang=ts&setup=true"
export * from "./CameraInfoNav.vue?vue&type=script&lang=ts&setup=true"

import "./CameraInfoNav.vue?vue&type=style&index=0&id=6ed99e2b&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ed99e2b"]])

export default __exports__